module.exports = __webpack_public_path__ + "public/images/og-image.e8b4e54663936a2bb66fddbab2dbc038.jpg";